import React from 'react'
import clsx from 'clsx'

import { Text } from '@wartek-id/text-v1'
import type { ButtonProps } from '@wartek-id/button-v1'
import { Button } from '@wartek-id/button-v1'
import type { TextProps } from '@wartek-id/text-v1'

import ErrorFixingIcon from 'assets/icons/img-error-fixing.svg'

export type GeneralNoticeStateProps = {
  title?: string
  titleVariant?: TextProps['variant']
  titleClassNames?: string

  description?: string | React.ReactNode
  descriptionVariant?: TextProps['variant']
  descriptionClassNames?: string

  // Container
  containerClassNames?: string

  // Icon
  icon?: JSX.Element

  // Button
  button?: React.ReactNode
  buttonColor?: ButtonProps['color']
  showButton?: boolean
  buttonLabel?: string
  buttonDisabled?: boolean
  onButtonClick?: any
}

const GeneralNoticeState = ({
  // Content
  title = 'Terjadi kendala sistem',
  titleVariant = 'heading-md',
  titleClassNames = '',
  description = 'Silakan coba lagi dalam beberapa saat.',
  descriptionVariant = 'body',
  descriptionClassNames = '',

  // Container
  containerClassNames = '',

  // Icon
  icon = null,

  // Button
  button = null,
  buttonColor = 'black',
  showButton = false,
  buttonLabel = 'Coba lagi',
  buttonDisabled = false,
  onButtonClick = () => {},
}: GeneralNoticeStateProps): JSX.Element => {
  return (
    <>
      <div className={containerClassNames}>
        {/* Icon */}
        <div className="flex items-center justify-center m-auto">
          {icon && <>{icon}</>}
          {!!!icon && (
            <ErrorFixingIcon
              width={120}
              height={120}
              className="select-none pointer-events-none"
            />
          )}
        </div>

        {/* Title */}
        <Text variant={titleVariant} className={clsx('mt-7', titleClassNames)}>
          {title}
        </Text>

        {/* Description */}
        <Text
          variant={descriptionVariant}
          color="subdued"
          className={clsx('mt-2', descriptionClassNames)}
        >
          {description}
        </Text>

        {/* Retry button */}
        {showButton && (
          <div className="mt-5">
            <Button
              color={buttonColor}
              fullWidth
              onClick={onButtonClick}
              size="lg"
              variant="solid"
              disabled={buttonDisabled}
            >
              {buttonLabel}
            </Button>
          </div>
        )}

        {/* Custom buttons, to only be displayed if the default button is hidden */}
        {!showButton && button}
      </div>
    </>
  )
}

GeneralNoticeState.displayName = 'GeneralNoticeState'

export default GeneralNoticeState
